module.exports = __webpack_public_path__ + "static/media/IMG_6408_2.f0052388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photos/IMG_6408_2.jpg
// module id = 212
// module chunks = 0